// extracted by mini-css-extract-plugin
export default {"root":"_2u3Kgz27","fetching":"adpzAog0","productsList":"_37SUECNi","listItem":"rTrs7jx2","sortable":"_2M3sBqeJ"};